import script from "./App.vue?vue&type=script&lang=ts&setup=true"
export * from "./App.vue?vue&type=script&lang=ts&setup=true"

import "./App.vue?vue&type=style&index=0&id=0a8076ff&lang=css"
import "./App.vue?vue&type=style&index=1&id=0a8076ff&scoped=true&lang=css"
import "./App.vue?vue&type=style&index=2&id=0a8076ff&lang=scss"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a8076ff"]])

export default __exports__